/* eslint-disable no-console */
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
const PanellistDetails = (props:any) =>
{
	const { joinDetails } = props;
	const [ open, setOpen ] = useState(null);

	const handleOpen = (e:any) =>
	{
		setOpen(e?.target);
	};
	const ITEM_HEIGHT = 48;

	return (
		<div className='flexCol'>
			<div className='flexAutoRow panlListWidth pdngXS'>
				<div className='flexCol'>
					{joinDetails?.panalListData?.length > 0 &&
					<div className='flexRow alignCntr pdngXXS'>
						<span className='headingMD fontWeightMD'>Panellist</span>
					</div>}
					<div className='resflexColRow'>
						{
							joinDetails?.panalListData?.length > 0 &&
					joinDetails?.panalListData?.slice(0, 2)?.map((panelList:any, index:any) => (
						<div className='flexRow alignCntr pdngXXS' key={panelList?._id ? panelList?._id : index}>
							<div className='flexAutoRow imgAvatarNewsSM brdrBlackSM brdrRadius50 countBgColor'>
								<LazyLoadImage
									src={panelList?.profileImage || panelList?.thumbnailImage || '/images/icons/defaultUser.svg'}
									alt='img'
									className='brdrRadius50'
									delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
									effect={process.env.REACT_APP_EFFECT}
									width={`${process.env.REACT_APP_IMG_WIDTH}%`}
									height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
								/>
							</div>
							<div className='panlListMinWidthCol pdngHXS wordBreakAll respdngHSM'>
								<span className='capitalTxt ellipsisTxtAutoWidth headingMD'>
									{panelList?.name || panelList?.email}
								</span>
								<span className='headingXSM'>Speaker</span>
							</div>

							{ index === 1 && joinDetails?.panalListData?.length > 2 &&
								<button tabIndex={0} onKeyUp={(e) => e.key === 'Enter' && handleOpen(e)} onClick={handleOpen}
									className='flexAutoRow alignCntr justifyCntr imgAvatarNewsSM brdrBlackSM brdrRadius50 userCount pointer'
								>
									<span className='whiteTxt'>+{joinDetails?.panalListData?.length - 2}</span>
								</button>}
						</div>
					))
						}
					</div>
				</div>
				<Menu
					id='basic-menu'
					anchorEl={open}
					open={Boolean(open)}
					onClose={() => handleOpen(null)}
					MenuListProps={{
						'aria-labelledby' : 'basic-button'
					}}
					PaperProps={{
						style : {
							maxHeight : ITEM_HEIGHT * 4.5,
							width     : '22ch'
						}
					}}
				>
					{joinDetails?.panalListData?.slice(2).map((panelList) =>
						(<MenuItem key={panelList?._id} onClick={() => handleOpen(null)}>
							<div className='flexRow alignCntr'>
								<div className='flexAutoRow imgAvatarNewsSM brdrBlackSM brdrRadius50 countBgColor'>
									<LazyLoadImage
										src={panelList?.profileImage || panelList?.thumbnailImage || '/images/icons/defaultUser.svg'}
										alt='img'
										className='brdrRadius50'
										delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
										effect={process.env.REACT_APP_EFFECT}
										width={`${process.env.REACT_APP_IMG_WIDTH}%`}
										height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
									/>
								</div>
								<div className='flexMinWidthRow respdngHSM'>
									{panelList?.name || panelList?.email}
								</div>
							</div>
						</MenuItem>
						)
					)}
				</Menu>
			</div>
		</div>
	);
};

export default PanellistDetails;
